import { isImgixUrl, resolveByosImgixSrc } from '@air/component-imgix-image';

/** Construct a poster frame URL for an imgix video using the video-thumbnail API. */
export const getVideoThumbnailUrl = (videoUrl: string): string => {
  const resolvedUrl = resolveByosImgixSrc(videoUrl);

  if (!isImgixUrl(resolvedUrl)) {
    return resolvedUrl;
  }

  try {
    const url = new URL(resolvedUrl);
    url.searchParams.set('video-thumbnail', 'auto');
    url.searchParams.set('fm', 'jpg');

    return url.toString();
  } catch {
    return resolvedUrl;
  }
};
